import { TranscriptRequestStatus } from '@sandtech-hub-monorepo/ehub-client';
import { Check, Clock, X } from 'lucide-react';

interface Props {
  status: TranscriptRequestStatus;
}

const RequestStatusPill = ({ status }: Props) => {
  switch (status) {
    case TranscriptRequestStatus.Approved:
      return (
        <span className="inline-flex items-center gap-1 rounded-full bg-success/10 text-success px-2.5 py-0.5 text-xs font-medium">
          <Check className="h-3 w-3" /> Sent
        </span>
      );
    case TranscriptRequestStatus.Rejected:
      return (
        <span className="inline-flex items-center gap-1 rounded-full bg-destructive/10 text-destructive px-2.5 py-0.5 text-xs font-medium">
          <X className="h-3 w-3" /> Rejected
        </span>
      );
    case TranscriptRequestStatus.Cancelled:
      return (
        <span className="inline-flex items-center rounded-full bg-muted text-muted-foreground px-2.5 py-0.5 text-xs font-medium">
          Cancelled
        </span>
      );
    default:
      return (
        <span className="inline-flex items-center gap-1 rounded-full bg-warning/10 text-warning px-2.5 py-0.5 text-xs font-medium">
          <Clock className="h-3 w-3" /> Under review
        </span>
      );
  }
};

export default RequestStatusPill;
